import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';
import { Typography } from '../../../../ui/Typography';

export const ReportSectionTextarea = styled.textarea<{ $isError: boolean }>`
  resize: none;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 15px;
  width: 100%;
  height: 230px;
  font-family: inherit;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 14px;
  padding: 15px;
  margin-bottom: ${({ $isError }) => ($isError ? '0' : '32px')};

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 346px;
    margin-bottom: ${({ $isError }) => ($isError ? '0' : '20px')};
  }
`;

export const buttonStyles = css`
  height: 57px;
`;

export const ReportError = styled(Typography)`
  display: block;
  margin: 10px 0 30px;
  color: ${({ theme }) => theme.colors.systemColors.red};

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 20px;
  }
`;
